const strings={de:['Weitere Produkte laden','Produkte werden geladen …','Erneut versuchen'],en:['Load more products','Loading products …','Try again'],fr:['Afficher plus de produits','Chargement …','Réessayer'],es:['Cargar más productos','Cargando …','Reintentar']};
class CollectionMore extends HTMLElement {
  connectedCallback(){
    this.observer?.disconnect();this.events?.abort();this.events=new AbortController();this.labels=strings[document.documentElement.lang.split('-')[0]]||strings.de;
    this.style.cssText='display:block;flex:0 0 100%;width:100%;grid-column:1/-1;text-align:center;padding:24px 0;min-height:72px';
    this.link=this.querySelector('a,button');if(!this.link)return;
    ensureBackToTop(this.closest('.collection-grid'));
    this.link.textContent=this.labels[0];this.link.style.cssText='display:inline-block;border:1px solid #222;border-radius:10px;padding:12px 20px;background:#111;color:#fff;cursor:pointer';
    this.link.onclick=e=>{e.preventDefault();this.failed=false;this.load();};
    this.parentElement.querySelectorAll(':scope > .element-pagination').forEach(e=>{e.hidden=true;e.style.display='none';});
    this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&!this.failed)this.load();},{rootMargin:'500px 0px'});this.observer.observe(this);
    this.check=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;if(!this.isConnected||this.failed||this.busy)return;const rect=this.getBoundingClientRect();const height=window.visualViewport?.height||window.innerHeight;if(rect.width&&rect.height&&rect.top<height+600&&rect.bottom>0)this.load();});};
    for(const event of ['scroll','resize','pageshow','touchend'])window.addEventListener(event,this.check,{passive:true,signal:this.events.signal});
    window.visualViewport?.addEventListener('resize',this.check,{passive:true,signal:this.events.signal});this.check();
  }
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.events?.abort();cancelAnimationFrame(this.frame);this.frame=0;}
  async load(){
    if(this.busy||!this.isConnected)return;this.busy=true;this.setAttribute('aria-busy','true');this.link.textContent=this.labels[1];
    try{
      if(this.loadBatch){await this.loadBatch(this);}
      else{
        const url=new URL(this.dataset.next,location.href);const section=this.closest('.shopify-section');if(section)url.searchParams.set('section_id',this.closest('section-main-content')?.querySelector('[data-lk-room-fast]')?'lk-room-cards':section.id.replace('shopify-section-',''));
        const theme=this.closest('[data-lk-theme-id]')?.dataset.lkThemeId;if(theme)url.searchParams.set('preview_theme_id',theme);
        const context=new URL(location.href);for(const key of ['preview_theme_id','view'])if(context.searchParams.has(key))url.searchParams.set(key,context.searchParams.get(key));
        this.controller=new AbortController();const r=await fetch(url,{credentials:'same-origin',signal:this.controller.signal});if(!r.ok)throw Error();
        const template=document.createElement('template');template.innerHTML=await r.text();const grid=template.content.querySelector('.collection-grid');if(!grid)throw Error();if(!this.isConnected)return;
        const seen=new Set([...this.parentElement.querySelectorAll('[data-product-id]')].map(e=>e.dataset.productId));
        const fragment=document.createDocumentFragment();for(const card of [...grid.children]){if(card.matches('lk-collection-more,.element-pagination,script'))continue;const id=card.querySelector('[data-product-id]')?.dataset.productId;if(!id||seen.has(id))continue;seen.add(id);card.querySelectorAll('img').forEach(i=>i.loading='lazy');fragment.append(card);}
        this.before(fragment);const next=grid.querySelector('lk-collection-more')?.dataset.next;
        if(next){this.dataset.next=next;this.link.href=next;}else this.remove();
      }
      this.failed=false;
    }catch(e){if(e.name!=='AbortError'){this.failed=true;this.link.textContent=this.labels[2];}}
    finally{this.busy=false;this.removeAttribute('aria-busy');if(!this.failed&&this.isConnected){this.link.textContent=this.labels[0];this.observer.unobserve(this);this.observer.observe(this);this.check?.();}}
  }
}
if(!customElements.get('lk-collection-more'))customElements.define('lk-collection-more',CollectionMore);
export function clientMore(grid,loader){const el=document.createElement('lk-collection-more');el.loadBatch=loader;const button=document.createElement('button');button.type='button';el.append(button);grid.append(el);return el;}

document.querySelectorAll('.collection-grid[data-lk-back-to-top-label]').forEach(ensureBackToTop);

function ensureBackToTop(grid) {
  if (!grid || document.getElementById('lk-collection-back-to-top')) return;
  const label = grid.dataset.lkBackToTopLabel;
  if (!label) return;
  const button = document.createElement('button');
  button.id = 'lk-collection-back-to-top';
  button.className = 'lk-collection-back-to-top';
  button.type = 'button';
  button.setAttribute('aria-label', label);
  button.title = label;
  button.hidden = true;
  button.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12 7-7 7 7M12 5v14"/></svg>';
  document.body.append(button);

  const selector = '#Sea-Accessibility__LoaderButton, #Sea-Accessibility__ButtonWidget';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  const widgets = new Set();
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  const resizeObserver = new ResizeObserver(schedule);

  function sync() {
    frame = 0;
    button.hidden = window.scrollY < 400;
    if (button.hidden) return;
    const viewport = window.visualViewport;
    const width = document.documentElement.clientWidth;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    let left = 16;
    let bottom = Math.max(20, window.innerHeight - viewportBottom + 20);
    const candidates = [...document.querySelectorAll(selector)];
    for (const widget of widgets) {
      if (!candidates.includes(widget)) { resizeObserver.unobserve(widget); widgets.delete(widget); }
    }
    for (const widget of candidates) {
      if (!widgets.has(widget)) { resizeObserver.observe(widget); widgets.add(widget); }
      const rect = widget.getBoundingClientRect();
      const style = getComputedStyle(widget);
      if (!rect.width || !rect.height || style.display === 'none' || style.visibility === 'hidden' || rect.bottom < 0 || rect.top >= viewportBottom) continue;
      left = rect.left >= 68 ? rect.left - 56 : rect.right + 12;
      bottom = window.innerHeight - rect.top - (rect.height + 44) / 2;
      break;
    }
    const nextLeft = `${Math.round(Math.max(12, Math.min(left, width - 56)))}px`;
    const nextBottom = `${Math.round(Math.max(12, bottom))}px`;
    if (button.style.left !== nextLeft) button.style.left = nextLeft;
    if (button.style.bottom !== nextBottom) button.style.bottom = nextBottom;
  }

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  });
  for (const event of ['scroll', 'resize', 'pageshow']) window.addEventListener(event, schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  const containsWidget = node => node instanceof Element && (node.matches(selector) || node.querySelector(selector));
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'childList'
      ? [...record.addedNodes, ...record.removedNodes].some(containsWidget)
      : record.target.matches(selector))) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
  schedule();
}
